<template>
    <inertia-head title="Nova Energy" />
    <v-app>
        <Header/>
        <v-main>
            <v-container class="custom-max-width">
                <slot></slot>
            </v-container>
        </v-main>
        <Footer :showFooterFaq="showFooterFaq" :showFooterGallery="showFooterGallery"/>
    </v-app>
</template>

<script>
import Header from "../Components/ReferralCampaigns/partials/Header.vue";
import Footer from "../Components/ReferralCampaigns/partials/Footer.vue";
export default {
    components: {
        Header,
        Footer,
    },
    props: {
        showFooterFaq: {
            type: Boolean,
            default: true
        },
        showFooterGallery: {
            type: Boolean,
            default: false
        }
    },
    created() {
        this.$vuetify.theme.name = 'referralTheme';
    }
}
</script>

<style lang="scss">

body {
    font-family: Poppins !important;
}

.custom-max-width {
    @media (min-width: 1280px) {
        max-width: 1200px;
    }

}
</style>
